import React from 'react';
import { PricingCard } from './OfferSection';
export function FooterSection() {
  return <footer className="bg-slate-900 text-slate-300 pt-24 pb-12 relative overflow-hidden" data-id="element-35">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[300px] bg-violet-900/20 blur-[100px] rounded-full pointer-events-none" data-id="element-36" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-37">
        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-38">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-39">
            Tu práctica clínica también merece más claridad
          </h2>
          <p className="text-lg text-slate-400 mb-10" data-id="element-40">
            No siempre la facultad prepara para todo lo que implica la clínica
            real.
            <br data-id="element-41" />
            Pero sí podés acompañarte con:
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-16" data-id="element-42">
            {['herramientas claras', 'estructuras profesionales', 'recursos editables', 'estrategias prácticas', 'más organización', 'más seguridad clínica'].map((tag, i) => <span key={i} className="bg-white/10 text-white text-sm font-medium px-4 py-2 rounded-full flex items-center gap-2" data-id="element-43">
                <span className="text-teal-400" data-id="element-44">🌸</span> {tag}
              </span>)}
          </div>

          <div className="bg-white rounded-3xl p-1 shadow-2xl max-w-lg mx-auto" data-id="element-45">
            <PricingCard data-id="element-46" />
          </div>
        </div>

        <div className="border-t border-slate-800 pt-12 flex flex-col items-center text-center" data-id="element-47">
          <div className="text-teal-400 font-bold tracking-[0.2em] text-sm uppercase mb-4" data-id="element-48">
            🌸 Aula Mater™
          </div>
          <p className="text-slate-400 max-w-md mb-8" data-id="element-49">
            Herramientas profesionales y recursos prácticos para fortalecer la
            práctica clínica psicopedagógica.
          </p>
          <div className="flex flex-col gap-2 text-sm text-slate-500 mb-12" data-id="element-50">
            <span data-id="element-51">📧 soporteaulamater@gmail.com</span>
            <span data-id="element-52">📲 Instagram: @aulamater_</span>
          </div>
          <div className="text-xs text-slate-600" data-id="element-53">
            © 2026 Aula Mater™ — Todos los derechos reservados.
          </div>
        </div>
      </div>
    </footer>;
}